"use strict";

import barba from "@barba/core";
import barbaPrefetch from "@barba/prefetch";
import {
	homeInit,
	projLeave,
	studyEnter,
	studyLeave,
	fromSudyLeave,
	aboutEnter,
	aboutLeave,
} from "./modules/animations";
import { home, nav, navReusables, study } from "./modules/general";
import { default as scrollBar } from "./modules/general/scroll-bar";

const navMain = document.querySelector(".nav__main");
const navSec = document.querySelector(".nav__sec");
const foot = document.querySelector(".foot");

(function () {
	const scrollers = document.querySelectorAll(".scroller");

	scrollers.forEach((scroller) => {
		const scrollerItem = scroller.querySelector(".scroller__list");
		const listItems = Array.from(scrollerItem.children);

		listItems.forEach((item) => {
			const clonedItem = item.cloneNode(true);

			clonedItem.setAttribute("aria-hidden", true);
			scrollerItem.appendChild(clonedItem);
		});
	});
})();

if (history.scrollRestoration) {
	history.scrollRestoration = "manual";
}

barba.use(barbaPrefetch);

barba.init({
	transitions: [
		{
			name: "home",
			to: { namespace: ["home"] },
			once({ next }) {
				homeInit(next.container);
			},
		},
		{
			name: "study-to-home",
			to: { namespace: ["home"] },
			from: { namespace: ["study"] },
			enter({ next }) {
				homeInit(next.container);
			},
		},
		{
			name: "about-to-home",
			to: { namespace: ["home"] },
			from: { namespace: ["about"] },
			enter({ next }) {
				homeInit(next.container);
			},
		},
		{
			name: "study",
			to: { namespace: ["study"] },
			once({ next }) {
				studyEnter(next.container);
			},
			leave: ({ current, trigger }) => fromSudyLeave(current.container, trigger),
			enter({ next }) {
				studyEnter(next.container);
			},
		},
		{
			name: "home-to-study",
			to: { namespace: ["study"] },
			from: { namespace: ["home"] },
			leave: ({ current, trigger }) => projLeave(current.container, trigger),
			enter({ next }) {
				studyEnter(next.container);
			},
		},
		{
			name: "about-to-study",
			to: { namespace: ["study"] },
			from: { namespace: ["about"] },
			enter({ next }) {
				studyEnter(next.container);
			},
		},
		{
			name: "about",
			to: { namespace: ["about"] },
			once({ next }) {
				aboutEnter(next.container);
			},
		},
		{
			name: "home-to-about",
			to: { namespace: ["about"] },
			from: { namespace: ["home"] },
			enter({ next }) {
				aboutEnter(next.container);
			},
		},
		{
			name: "study-to-about",
			to: { namespace: ["about"] },
			from: { namespace: ["study"] },
			enter({ next }) {
				aboutEnter(next.container);
			},
		},
	],
	views: [
		{
			namespace: "home",
			afterOnce() {
				nav();
				navReusables.toggleNav("main");
				foot.classList.toggle("hide");
			},
			beforeLeave() {
				if (!navSec.classList.contains("hide")) navReusables.toggleNav("sec");
				if (!navMain.classList.contains("hide")) navReusables.toggleNav("main");
				foot.classList.toggle("hide");
			},
			afterEnter() {
				nav();
				home("hero");
				navReusables.toggleNav("main");
				foot.classList.toggle("hide");
			},
		},
		{
			namespace: "study",
			afterOnce({ current, next }) {
				nav();
				study();
				scrollBar(null, next.container);
			},
			beforeLeave({ current, next }) {
				navReusables.toggleNav("main");
				scrollBar(current.container, null);
			},
			afterEnter({ current, next }) {
				nav();
				study(next.container);
				scrollBar(null, next.container);
			},
		},
		{
			namespace: "about",
			afterOnce() {
				nav();
				navReusables.toggleNav("main");
				foot.classList.toggle("hide");
				foot.classList.add("solid");
				navMain.classList.add("solid");
			},
			beforeLeave() {
				navReusables.toggleNav("main");
				foot.classList.toggle("hide");
				foot.classList.remove("solid");
				navMain.classList.remove("solid");
			},
			afterEnter() {
				nav();
				window.scrollTo({ top: 0, left: 0, behavior: "instant" });
				navReusables.toggleNav("main");
				foot.classList.toggle("hide");
				foot.classList.add("solid");
				navMain.classList.add("solid");
			},
		},
	],
});
